import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=677c76ea&"
import script from "./DataTables.vue?vue&type=script&lang=js&"
export * from "./DataTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports